import React, { useState, useEffect, useContext } from 'react';
import api from '~/services/api';
import DocsInt from '~/interfaces/Docs';
import './styles.css';

// Contexts
import { GeneralContext } from '~/contexts';

// Import Components
import AdminDesign from '~/components/Admin';
import DocBox from '~/components/Boxs/Documents';
import Loading from '~/components/Default/Loading';
import cryptos from '~/utils/cryptos';

const Documents: React.FC = () => {
    // Contexts
    const { user, unit } = useContext(GeneralContext);

    // States
    const [ready, setReady]         = useState<Boolean>();
    const [subtitle, setSubtitle]   = useState<string>('Meus Documentos');
    const [documents, setDocuments] = useState<DocsInt[]>([]);

    // Folder Settings
    const unitFolder     = cryptos.encryptServer(unit.id + '-' + unit.folder);
    const urlInit        = 'documents/user/' + unitFolder;
    const [url, setUrl]  = useState<string>(urlInit);

    function changeDocuments(type?: string) {
        setReady(false);
        let urlDoc = '';

        if (type && type==='user') {
            urlDoc = urlInit;
            setSubtitle('Meus Documentos');
        } else {
            urlDoc = 'documents';
            setSubtitle('Documentos Serena');
        }

        setUrl(urlDoc);
    }

    useEffect(() => {
        api.get(url, {
            headers: { Authorization: user.token }
        }).then(resp => {
            setDocuments(resp.data);
            setReady(true);
        });
    }, [user, url]);

    return (
        <AdminDesign pageTitle="Documentos - Clientes Serena" title="Documentos" subtitle={subtitle} classMain="documents">
            <div className="buttons">
                <button className={'me' + (ready ? '' : ' noReady') + (url.indexOf('documents/user')>=0 ? ' active' : '')} onClick={() => (url.indexOf('documents/user')<0 ? changeDocuments('user') : '')}>
                    Meus Documentos
                </button>

                <button className={'srn' + (ready ? '' : ' noReady') + (url==='documents' ? ' active' : '')} onClick={() => (url!=='documents' ? changeDocuments() : '')}>
                    Serena
                </button>
            </div>

            <div className="docs">
                {
                    ready ?
                    (
                        documents.length>0 ?
                        documents.map(doc => <DocBox key={doc.id} {...doc} token={user.token} doc_ref={subtitle} />) :
                        <div className="alert">Nenhum documento localizado nesta pasta</div>
                    ) : <div className="alert"><Loading /></div>
                }
            </div>

        </AdminDesign>
    );
}

export default Documents;